import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "21",
  height: "10",
  viewBox: "0 0 21 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M20.4419 5.44194C20.686 5.19787 20.686 4.80214 20.4419 4.55806L16.4645 0.580584C16.2204 0.336506 15.8247 0.336506 15.5806 0.580584C15.3365 0.824662 15.3365 1.22039 15.5806 1.46447L19.1161 5L15.5806 8.53554C15.3365 8.77961 15.3365 9.17534 15.5806 9.41942C15.8247 9.6635 16.2204 9.6635 16.4645 9.41942L20.4419 5.44194ZM-5.46392e-08 5.625L20 5.625L20 4.375L5.46392e-08 4.375L-5.46392e-08 5.625Z",
      fill: ""
    }, null, -1)
  ])))
}
export default { render: render }